// extracted by mini-css-extract-plugin
module.exports = {"select":"single-dropdown_select__lHiO1","label":"single-dropdown_label__E5fIg","dropdown":"single-dropdown_dropdown__dp6Fl","child":"single-dropdown_child__P59Kn"};